import { render, staticRenderFns } from "./textImageStanding.vue?vue&type=template&id=db4b13e6&scoped=true"
import script from "./textImageStanding.vue?vue&type=script&lang=ts"
export * from "./textImageStanding.vue?vue&type=script&lang=ts"
import style0 from "./textImageStanding.vue?vue&type=style&index=0&id=db4b13e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4b13e6",
  null
  
)

export default component.exports